module.exports = __webpack_public_path__ + "img/image19@2x.606a5ca1.png";